window.addEventListener("DOMContentLoaded", () => {
    setTimeout(() => {
        const selects = document.querySelectorAll("form select.hs-input");
        selects.forEach((select) => {
            select.setAttribute("style", `--length: ${select.value.length}ch;`);
            //console.log("holaaa");
            if (select.nextElementSibling) {
                select.nextElementSibling.setAttribute("style", `--length: ${select.value.length}ch;`);
            }
        });

        selects.forEach((select) => {
            select.addEventListener("change", (event) => {
                select.setAttribute("style", `--length: ${event.target.value.length}ch;`);
                if (select.nextElementSibling) {
                    select.nextElementSibling.setAttribute("style", `--length: ${select.value.length}ch;`);
                }
            });
        });
    }, 1000);
});
